(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["actividad_administrativa_detail"] = factory();
	else
		root["actividad_administrativa_detail"] = factory();
})(self, () => {
return 